var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosebutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.852,
    height: 126.852,
    viewBox: "0 0 126.852 126.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{opacity:0.3;}.c{fill:#ce0024;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-853.074 -2673.074)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M63.426,0A63.426,63.426,0,1,1,0,63.426,63.426,63.426,0,0,1,63.426,0Z",
    transform: "translate(853.074 2673.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.449,0A51.449,51.449,0,1,1,0,51.449,51.449,51.449,0,0,1,51.449,0Z",
    transform: "translate(865.051 2685.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M42.359,0A42.359,42.359,0,1,1,0,42.359,42.359,42.359,0,0,1,42.359,0Z",
    transform: "translate(874.141 2694.253)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(901.372 2721.484)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 4.538,
    height: 36.307,
    transform: "translate(25.673 0) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 4.538,
    height: 36.307,
    transform: "translate(28.882 25.673) rotate(135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosebutton);
export default __webpack_public_path__ + "static/media/closebutton.dd8c9d385a90ba5a2897f900e170aa7c.svg";
export { ForwardRef as ReactComponent };